// extracted by mini-css-extract-plugin
module.exports = {"skills":"skills_skills__uX7Gt","header":"skills_header__1xHrf","skill_content":"skills_skill_content__DY6_B"};